import React from "react";
import { Navigate } from "react-router-dom";
import { useIsTenantAdmin } from "../../hooks/useIsTenantAdmin";

/** Guards tenant-only routes: non-TENANT_ADMIN users are bounced to home. */
export function RequireRole({ children }: { children: React.ReactNode }) {
  return useIsTenantAdmin() ? <>{children}</> : <Navigate to="/" replace />;
}
